import * as yup from 'yup';

const schema = yup.object().shape({
  message: yup.string().required(),
});

export default schema;
